__turbopack_context__.v({
  "action": "BsSXFa_action",
  "banner": "BsSXFa_banner",
  "content": "BsSXFa_content",
  "description": "BsSXFa_description",
  "dismiss": "BsSXFa_dismiss",
  "error": "BsSXFa_error",
  "info": "BsSXFa_info",
  "success": "BsSXFa_success",
  "title": "BsSXFa_title",
  "warning": "BsSXFa_warning",
});
